<template>
  <div>
    <a-modal
      id="handitem_k"
      v-model="visible"
      width="720px"
      on-ok="handleOk1"
      @cancel="handleCancel(0)"
      :footer="null"
      :keyboard="false"
      :maskClosable="false"
      :dialog-style="{ top: onlinestate == 'pc' ? '26%' : onlinestate == 'ipad' ? '22vh' : '22vh'}"
    >
      <div class="mark-file">
        <div
          v-if="onlinestate == 'pc'"
          style="width: 684px; font-size: 18px; color: #0c8b97;font-family: Roboto,Microsoft JhengHei,'sans-serif' !important; font-weight: 600;"
        >
          {{ params.title }}
        </div>
        <div v-else class="myland" :style="{ fontSize: islang == 'eng' ?'15px':'17px',fontWeight: islang == 'eng' ?'600':'600'}">
          {{ params.title }}
        </div>
      </div>
      <div solt="title" style="position: relative">
        <!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
      </div>
      <div
        style="
          max-height: 22rem;
          overflow: auto;
          font-size: 16px;
          margin: 0.5rem 0;
          color: #000;
        "
      >
        <!-- <div class='look_w' style="margin-bottom: 1rem;">{{params.text_welcome}}</div> -->
        <pre
          class="fonts look_l"
          :style="{ lineHeight: islang !== 'eng' ? '25px' : '' ,fontSize: onlinestate == 'pc' ?'16px':'16px'}"
          v-html="params.text_body"
          id="a_pre"
          v-if="onlinestate == 'pc'"
        ></pre>
        <pre
          class="fonts look_l"
          :style="{ lineHeight: islang !== 'eng' ? '25px' : '' , fontSize:  islang == 'eng' ?'14px':'16px'}"
          v-html="params.text_body"
          id="a_pre"
          v-else
        ></pre>
        <!-- <pre class='fonts look_l' >
          <a href="https://www.hkex.com.hk/-/media/HKEX-Market/Services/Circulars-and-Notices/Participant-and-Members-Circulars/SEHK/2021/cc_SEHK_CT_086_2021.pdf" target="_blank">https://www.chiefgroup.com.hk/hk/financial/news-archive?rl=Main_NewsA&type=company</a>
        </pre> -->
        <pre class="fonts look_l look_w" style="margin: 0.8rem 0 0.6rem;" :style="{ fontSize: onlinestate == 'pc' ?'16px':'16px'}" v-if="onlinestate == 'pc'">{{
          params.nitice_text_company
        }}</pre>
        <pre class="fonts look_l look_w" style="margin: 0.8rem 0 0.6rem;" :style="{ fontSize:  islang == 'eng' ?'14px':'16px'}" v-else>{{
          params.nitice_text_company
        }}</pre>
        <!-- <pre class='fonts look_l'>{{params.notice_text_final}}</pre> -->
      </div>
      <div style="margin-bottom: 1rem">
        <button id="mybtn_dow_k" v-if="params.attachment" @click="handopen" :style="{ fontSize: onlinestate == 'pc' ?'16px':'15px'}">
          {{ params.attachment }}
        </button>
      </div>
      <button id="mybtn_s_k" @click="handleCancel" :style="{ fontSize: onlinestate == 'pc' ?'16px':'15px'}">{{ $lang.isBack }}</button>
    </a-modal>
  </div>
</template>

<script>
export default {
  props: ["items"],
  data() {
    return {
      islang: window.localStorage.guanwanglang,
      onlinestate: sessionStorage["onlinestate"],
      visible: true,
      text: "text",
      activeKey: "",
      params: {},
    };
  },
  mounted() {
    this.getdate();
    console.log(this.onlinestate, "------------------");
  },
  methods: {
    handopen() {
      if (this.params.attachment_url) {
        window.open(this.params.attachment_url);
      }
    },
    getdate() {
      this.$ajax({
        method: "post",
        url: this.$api.getNoticeWithid,
        data: {
          lan: window.localStorage.guanwanglang,
          noticeid: this.items.noticeid,
        },
      }).then((res) => {
        if (res.data.qmiscode === 1000) {
          this.params = res.data;
        }
      });
    },
    handleCancel() {
      this.$emit("child");
    },
    handleOk() {},
    handleClick(event) {
      // If you don't want click extra trigger collapse, you can prevent this:
      event.stopPropagation();
    },
  },
};
</script>

<style>
#a_pre a {
  color: #000000;
  font-weight: 600;
}
#a_pre a:hover {
  color: #09666e;
}

#mybtn_s_k {
  cursor: pointer;
  color: #fff;
  font-size: 16px;
  background-color: #0c8b97;
  border: 0;
  outline: none;
  width: 6rem;
  padding: 0.4rem 0.6rem;
  border-radius: 4px;
  border: 1px solid #fff;
}
#mybtn_s_k:hover {
  background-color: #fff;
  color: #0c8b97;
  border: 1px solid #0c8b97;
}
#mybtn_dow_k {
  cursor: pointer;
  color: #fff;
  font-size: 16px;
  background-color: #0c8b97;
  border: 0;
  outline: none;
  padding: 0.3rem 0.6rem;
  border-radius: 4px;
}
#handitem_k .ant-modal-close-x {
  /* width: 1rem; */
  /* height: 1rem; */
  font-size: 18px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  top: 0;
}

#handitem_k .ant-modal-content {
  border-radius: 0 !important;
}

#handitem_k .ant-modal-body {
  border: 10px solid #09666e;
  border-left: 0;
  border-right: 0;
}
.myland {
  width: 240px;
  font-size: 18px;
  color: #0c8b97;
  margin: 0 auto;
  text-align: center;
}
@media screen and (max-width: 1100px) {
  .myland {
    width: 500px;
    font-size: 18px;
    color: #0c8b97;
    margin: 0 auto;
    text-align: center;
  }
}
@media screen and (max-width: 600px) {
  .myland {
    width: 240px;
    font-size: 16px;
    font-weight: 600;
    color: #0c8b97;
    margin: 0;
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/sujufuwu/handitem.vue